var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mb-6" }, [
    _c(
      "div",
      [
        _vm._event.private
          ? _c(
              "span",
              {
                staticClass:
                  "absolute bg-blue-gradient uppercase m-4 px-2 py-1 text-base rounded",
              },
              [_vm._v("\n      Private Event\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "router-link",
          {
            staticClass: "no-underline",
            attrs: {
              to: { name: "events-basics", params: { id: this._event.id } },
            },
          },
          [
            _c("img", {
              staticClass: "rounded-lg shadow-lg",
              staticStyle: { height: "218px", "object-fit": "cover" },
              attrs: {
                alt: _vm._event.title,
                src: _vm._event.image
                  ? _vm._event.image + "?auto=format&fit=crop&h=619&w=1024"
                  : "/img/hems-event-holder.png",
              },
            }),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "pt-2", class: _vm.statusClasses }, [
      _vm._v("\n    " + _vm._s(_vm.statusText) + "\n  "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "event-spacer" }),
    _vm._v(" "),
    _c(
      "h3",
      { staticClass: "text-2xl font-sans text-n-gray-dark font-hairline" },
      [
        _c(
          "router-link",
          {
            staticClass: "no-underline",
            attrs: {
              to: { name: "events-basics", params: { id: this._event.id } },
            },
          },
          [_vm._v("\n      " + _vm._s(_vm._event.title) + "\n    ")]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "event-spacer" }),
    _vm._v(" "),
    _c("div", {
      staticClass: "text-base",
      domProps: { innerHTML: _vm._s(_vm._event.teaser) },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "event-spacer" }),
    _vm._v(" "),
    _c("div", { staticClass: "uppercase" }, [
      _c("div", { staticClass: "text-base font-sans-bold" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm._f("moment")(_vm._event.start_at, "ddd. MMMM DD")) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _vm._event.venue
        ? _c(
            "div",
            { staticClass: "text-2xl leading-tight font-sans-bold" },
            [
              _vm._event.type === "physical" || _vm._event.venue.url
                ? [_vm._v("@")]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm._event.venue
      ? _c(
          "div",
          { staticClass: "text-base" },
          [
            _vm._event.venue.url && _vm._event.type !== "physical"
              ? _c("div", [
                  _c(
                    "a",
                    { attrs: { target: "_blank", href: _vm._event.venue.url } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm._event.venue.name) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("br"),
                ])
              : _c("div", [
                  _vm._v("\n      " + _vm._s(_vm._event.venue.name) + "\n    "),
                ]),
            _vm._v(" "),
            _vm._event.type === "physical"
              ? [_vm._v(_vm._s(_vm._event.venue.address_1))]
              : _vm._e(),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _vm._event.venue.city
              ? _c("span", [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm._event.venue.city) +
                      ", " +
                      _vm._s(_vm._event.venue.state) +
                      " " +
                      _vm._s(_vm._event.venue.zip) +
                      "\n    "
                  ),
                ])
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm._event.start_at && _vm._event.end_at
      ? _c("div", { staticClass: "text-base" }, [
          _vm._v(
            "\n    " +
              _vm._s(_vm._f("moment")(_vm._event.start_at, "h:mm")) +
              " - " +
              _vm._s(_vm._f("moment")(_vm._event.end_at, "h:mm A")) +
              " PDT\n  "
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }